import { Link, useLocation } from "react-router-dom";
import { Trophy, GitBranch, History as HistoryIcon, Layers, BarChart3 } from "lucide-react";

const NAV = [
  { to: "/", label: "Simulator", icon: Trophy, testid: "nav-simulator" },
  { to: "/compare", label: "Compare", icon: BarChart3, testid: "nav-compare" },
  { to: "/tournament", label: "Tournament", icon: Layers, testid: "nav-tournament" },
  { to: "/bracket", label: "Bracket", icon: GitBranch, testid: "nav-bracket" },
  { to: "/history", label: "History", icon: HistoryIcon, testid: "nav-history" },
];

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 border-b border-zinc-800 bg-black/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-3.5">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center bg-[#CCFF00] text-black">
            <span className="font-display text-2xl font-black leading-none">26</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg font-black uppercase tracking-tight">
              World Cup &lsquo;26
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
              Match Simulator
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          {NAV.map((item) => {
            const active = item.to === "/" ? pathname === "/" : pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={`flex items-center gap-2 px-4 py-2 font-display text-sm font-bold uppercase tracking-widest transition-colors ${
                  active
                    ? "bg-[#CCFF00] text-black"
                    : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
                }`}
              >
                <Icon className="h-4 w-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
